import React from "react";
import { Div, Text, Image } from "atomize";
import CustomContainer from "../common/CustomContainer";

export default function CombinationSection() {
  return (
    <Div tag="section" data-scroll-section p={{ xs: "7.5rem 0 5.75rem", lg: "14rem 0 9.75rem" }}>
      <CustomContainer pos="relative" zIndex="1">
        <Text tag="h3" textWeight="300" maxW={{ xs: "36rem", lg: "48rem", xl: "79rem" }} m="0 auto" textSize={{ xs: "subheader", lg: "header", xl: "title2" }} textAlign="center">
          Create captivating{" "}
          <Div tag="span" fontFamily="tertiary" className="custom-underline">
            <i>websites, presentations, artworks, apps,</i>
          </Div>{" "}
          and more without the hassle of creating models from scratch.
        </Text>
      </CustomContainer>
      <Div pos="relative" id="examples" overflow="visible" className="overflow-x-hidden">
        <Div data-scroll data-scroll-speed="-1" pos="absolute" top={{ xs: "-20%", sm: '0%', md: '0%', xl: "-40%" }} overflow="visible" left="0" right="0" w="100%">
          <Image d={{ xs: 'none', md: 'block' }} src="/images/grain/grain-bg-desktop.jpg" alt="grain-bg-desktop" />
          <Image d={{ xs: 'block', md: 'none' }} src="/images/grain/grain-bg-mobile.jpg" alt="grain-bg-mobile" />
          <Div className="noise img" />
        </Div>
        <Div overflow={{ xs: "hidden", md: "visible" }}>
          <CustomContainer overflow="visible">
            <Div overflow="visible" pos="relative" m={{ t: { xs: "7.5rem", lg: "9rem", xl: "14rem" } }} p={{ b: { xs: "103%", md: '45.5%' } }}>
              {desktopImages.map((image, index) => (
                <Image
                  key={`${image.src}-desktop-${index}`}
                  data-scroll
                  d={{ xs: 'none', md: "block" }}
                  pos="absolute"
                  {...image}
                />
              ))}
              {mobileImages.map((image, index) => (
                <Image
                  key={`${image.src}-mobile-${index}`}
                  d={{ xs: 'block', md: "none" }}
                  pos="absolute"
                  {...image}
                />
              ))}
            </Div>
          </CustomContainer>
        </Div>
      </Div>
    </Div>
  );
}


const mobileImages = [{
  src: "/images/combination-images/image1.png",
  top: '0',
  left: '0',
  w: '45.2%',
  alt: "example-image-mobile-1",
}, {
  src: "/images/combination-images/image2.png",
  top: '4.5%',
  left: '48.8%',
  w: '48.5%',
  alt: "example-image-mobile-2",
}, {
  src: "/images/combination-images/image3.jpg",
  top: '47.5%',
  left: '93.5%',
  w: '13.5%',
  alt: "example-image-mobile-3",
}, {
  src: "/images/combination-images/image4.jpg",
  top: '67%',
  left: '59.7%',
  w: '22.68%',
  alt: "example-image-mobile-4",
}, {
  src: "/images/combination-images/image5.jpg",
  top: '29.5%',
  left: '12.8%',
  w: '25.5%',
  alt: "example-image-mobile-5",
}, {
  src: "/images/combination-images/image6.jpg",
  top: '34%',
  left: '-6.9%',
  w: '13.6%',
  alt: "example-image-mobile-6",
}, {
  src: "/images/combination-images/image7.jpg",
  top: '35.5%',
  left: '45.4%',
  w: '40.5%',
  alt: "example-image-mobile-7",
}, {
  src: "/images/combination-images/image8.png",
  top: '73.5%',
  left: '6.95%',
  w: '47.5%',
  alt: "example-image-mobile-8",
}]


const desktopImages = [{
  src: "/images/combination-images/image1.png",
  top: '0%',
  left: '0',
  w: '28%',
  "data-scroll-speed": '1.5',
  alt: "example-image-desktop-1",
}, {
  src: "/images/combination-images/image2.png",
  top: '6.77%',
  left: '34.5%',
  w: '30.9%',
  "data-scroll-speed": '1',
  alt: "example-image-desktop-2",
}, {
  src: "/images/combination-images/image3.jpg",
  top: '17%',
  left: '70.7%',
  w: '7.3%',
  "data-scroll-speed": '1.5',
  alt: "example-image-desktop-3",
}, {
  src: "/images/combination-images/image4.jpg",
  top: '0%',
  left: '83.5%',
  w: '14.3%',
  "data-scroll-speed": '2',
  alt: "example-image-desktop-4",
}, {
  src: "/images/combination-images/image5.jpg",
  top: '53.2%',
  left: '2.2%',
  w: '14.3%',
  "data-scroll-speed": '1.5',
  alt: "example-image-desktop-5",
}, {
  src: "/images/combination-images/image6.jpg",
  top: '48.6%',
  left: '21.9%',
  w: '7.3%',
  "data-scroll-speed": '2',
  alt: "example-image-desktop-6",
}, {
  src: "/images/combination-images/image7.jpg",
  top: '61.23%',
  left: '37.5%',
  w: '25%',
  "data-scroll-speed": '1',
  alt: "example-image-desktop-7",
}, {
  src: "/images/combination-images/image8.png",
  top: '65.53%',
  left: '71.9%',
  w: '28%',
  "data-scroll-speed": '1.5',
  alt: "example-image-desktop-8",
}]